import Dashboard from "layouts/dashboard";
import Tables from "layouts/tables";
import Billing from "layouts/billing";
import RTL from "layouts/rtl";
import Notifications from "layouts/notifications";
import Profile from "layouts/profile";
import DocumentPage from "layouts/DocumentPage/DocumentPage";
import DocumentViewer from "layouts/DocumentViewer/DocumentViewer";
import SupplierPage from "layouts/suppliers/SupplierPage";
import WarehousePage from "layouts/Warehouse/WarehousePage";
import CompanyManagement from "layouts/company/CompanyManagement"; // Import the new component
import UserManagement from "layouts/users/UserManagement";
import SignIn from "layouts/authentication/sign-in";
import SignUp from "layouts/authentication/sign-up";
import Logout from "layouts/authentication/logout/logout";
import Icon from "@mui/material/Icon";
import LLMSettings from "layouts/LLMSettings/LLMSettings";

const getRoutes = (t) => [
  {
    type: "route",
    name: t("signIn"),
    key: "sign-in",
    icon: <Icon fontSize="small">login</Icon>,
    route: "/authentication/sign-in",
    component: <SignIn />,
    invisible: true,
  },
  {
    type: "route",
    name: t("signUp"),
    key: "sign-up",
    route: "/authentication/sign-up",
    component: <SignUp />,
    protected: false,
    invisible: true,
  },
  {
    type: "route",
    name: "Dashboard",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/dashboard",
    component: <Dashboard />,
    protected: true,
    invisible: true,
  },
  {
    type: "route",
    name: "Tables",
    key: "tables",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/tables",
    component: <Tables />,
    protected: true,
    invisible: true,
  },
  {
    type: "route",
    name: "Billing",
    key: "billing",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/billing",
    component: <Billing />,
    protected: true,
    invisible: true,
  },
  {
    type: "collapse",
    name: t("company"),
    key: "company-management",
    icon: <Icon fontSize="small">business</Icon>,
    route: "/company-management",
    component: <CompanyManagement />,
    protected: true,
    invisible: false,
  },
  {
    type: "collapse",
    name: t("documents"),
    key: "documents",
    icon: <Icon fontSize="small">description</Icon>,
    route: "/documents",
    component: <DocumentPage />,
    protected: true,
    invisible: false,
  },
  {
    type: "collapse",
    name: t("suppliers"),
    key: "suppliers",
    icon: <Icon fontSize="small">group</Icon>,
    route: "/suppliers",
    component: <SupplierPage />,
    protected: true,
    invisible: false,
  },
  {
    type: "collapse",
    name: t("warehouse"),
    key: "warehouse",
    icon: <Icon fontSize="small">warehouse</Icon>,
    route: "/warehouse",
    component: <WarehousePage />,
    protected: true,
    invisible: false,
  },
  {
    type: "route",
    name: "Document Viewer",
    key: "document-viewer",
    route: "/documents/:id",
    component: <DocumentViewer />,
    protected: true,
    invisible: true,
  },
  {
    type: "route",
    name: "RTL",
    key: "rtl",
    icon: <Icon fontSize="small">format_textdirection_r_to_l</Icon>,
    route: "/rtl",
    component: <RTL />,
    protected: true,
    invisible: true,
  },
  {
    type: "route",
    name: "Notifications",
    key: "notifications",
    icon: <Icon fontSize="small">notifications</Icon>,
    route: "/notifications",
    component: <Notifications />,
    protected: true,
    invisible: true,
  },
  {
    type: "route",
    name: t("profile"),
    key: "profile",
    icon: <Icon fontSize="small">person</Icon>,
    route: "/profile",
    component: <Profile />,
    protected: true,
    invisible: true,
  },
  {
    type: "collapse",
    name: t("llmSettings"),
    key: "llm-settings",
    icon: <Icon fontSize="small">settings</Icon>,
    route: "/llm-settings",
    component: <LLMSettings />,
    protected: true,
    invisible: false,
  },
  {
    type: "collapse",
    name: t("userManagement"),
    key: "user-management",
    icon: <Icon fontSize="small">manage_accounts</Icon>,
    route: "/user-management",
    component: <UserManagement />,
    protected: true,
    invisible: false,
  },
  {
    type: "collapse",
    name: t("logout"),
    key: "logout",
    icon: <Icon fontSize="small">logout</Icon>,
    route: "/logout",
    component: <Logout />,
    protected: true,
    invisible: false,
  },
];

// Default routes for backward compatibility
const routes = [
  {
    type: "route",
    name: "Sign In",
    key: "sign-in",
    icon: <Icon fontSize="small">login</Icon>,
    route: "/authentication/sign-in",
    component: <SignIn />,
    invisible: true,
  },
  {
    type: "route",
    name: "Registracija",
    key: "sign-up",
    route: "/authentication/sign-up",
    component: <SignUp />,
    protected: false,
    invisible: true,
  },
  {
    type: "route",
    name: "Dashboard",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/dashboard",
    component: <Dashboard />,
    protected: true,
    invisible: true,
  },
  {
    type: "route",
    name: "Tables",
    key: "tables",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/tables",
    component: <Tables />,
    protected: true,
    invisible: true,
  },
  {
    type: "route",
    name: "Billing",
    key: "billing",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/billing",
    component: <Billing />,
    protected: true,
    invisible: true,
  },
  {
    type: "collapse",
    name: "Company",
    key: "company-management",
    icon: <Icon fontSize="small">business</Icon>,
    route: "/company-management",
    component: <CompanyManagement />,
    protected: true,
    invisible: false,
  },
  {
    type: "collapse",
    name: "Documents",
    key: "documents",
    icon: <Icon fontSize="small">description</Icon>,
    route: "/documents",
    component: <DocumentPage />,
    protected: true,
    invisible: false,
  },
  {
    type: "collapse",
    name: "Suppliers",
    key: "suppliers",
    icon: <Icon fontSize="small">group</Icon>,
    route: "/suppliers",
    component: <SupplierPage />,
    protected: true,
    invisible: false,
  },
  {
    type: "collapse",
    name: "Warehouse",
    key: "warehouse",
    icon: <Icon fontSize="small">warehouse</Icon>,
    route: "/warehouse",
    component: <WarehousePage />,
    protected: true,
    invisible: false,
  },
  {
    type: "route",
    name: "Document Viewer",
    key: "document-viewer",
    route: "/documents/:id",
    component: <DocumentViewer />,
    protected: true,
    invisible: true,
  },
  {
    type: "route",
    name: "RTL",
    key: "rtl",
    icon: <Icon fontSize="small">format_textdirection_r_to_l</Icon>,
    route: "/rtl",
    component: <RTL />,
    protected: true,
    invisible: true,
  },
  {
    type: "route",
    name: "Notifications",
    key: "notifications",
    icon: <Icon fontSize="small">notifications</Icon>,
    route: "/notifications",
    component: <Notifications />,
    protected: true,
    invisible: true,
  },
  {
    type: "route",
    name: "Profile",
    key: "profile",
    icon: <Icon fontSize="small">person</Icon>,
    route: "/profile",
    component: <Profile />,
    protected: true,
    invisible: true,
  },
  {
    type: "collapse",
    name: "LLM Settings",
    key: "llm-settings",
    icon: <Icon fontSize="small">settings</Icon>,
    route: "/llm-settings",
    component: <LLMSettings />,
    protected: true,
    invisible: false,
  },
  {
    type: "collapse",
    name: "Logout",
    key: "logout",
    icon: <Icon fontSize="small">logout</Icon>,
    route: "/logout",
    component: <Logout />,
    protected: true,
    invisible: false,
  },
];

export { getRoutes };
export default routes;
